
export const redirectFBMSN = (
    base_url,
    path,
    store_id = null,
    ref_store_id = null,
    id = null,
    store_product_id = null,
    store_assort_id = null,
    quantity = null,
) => {
    let query_params = {
        ref: window.btoa(window.location.href),
        store_id,
        ref_store_id,
        device_uuid: Cookies.get("_DEVICE_UUID_"),
    }
    if (id) {
        query_params['id'] = id
    }
    if (store_product_id) {
        query_params['store_product_id'] = store_product_id
    }
    if (store_assort_id) {
        query_params['store_assort_id'] = store_assort_id
    }
    if (quantity) {
        query_params['quantity'] = quantity
    }
    if (Cookies.get("aib_lkuid")) {
        query_params["aib_lkuid"] = Cookies.get("aib_lkuid")
    }
    if (Cookies.get("aib_cid")) {
        query_params["aib_cid"] = Cookies.get("aib_cid")
    }
    // 加 `gclid`, `fbclid`, `ttclid`, `ldtag_cl` 至轉址參數中
    let _gclid = Cookies.get("gclid") || window.localStorage?.getItem("gclid");
    if (_gclid) {
        query_params["gclid"] = _gclid;
    }
    let _fbclid = Cookies.get("fbclid") || window.localStorage?.getItem("fbclid");
    if (_fbclid) {
        query_params["fbclid"] = _fbclid;
    }
    let _ttclid = Cookies.get("ttclid") || window.localStorage?.getItem("ttclid");
    if (_ttclid) {
        query_params["ttclid"] = _ttclid;
    }
    let _ldtag_cl = Cookies.get("ldtag_cl") || window.localStorage?.getItem("ldtag_cl");
    if (_ldtag_cl) {
        query_params["ldtag_cl"] = _ldtag_cl;
    }
    // const fbmsn_url = base_url + path + "?" + jQuery.param(query_params)
    const fbmsn_url =  "/redirect-to-fbn?path=" + path + "&" + jQuery.param(query_params)

    // console.debug("query_params", query_params)
    // console.debug("fbmsn_url", fbmsn_url)

    window.open(fbmsn_url, "_self")
}
